export enum FeedbackSource {
	EDITOR = 'Editor',
	HELP_PANEL = 'Help Panel',
	THEME_SELECTOR = 'Theme Selector',
	WHITEBOARD = 'Whiteboard',
	EMBED = 'Embed',
	DATABASE = 'Database',
}
